<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">生命科學、醫療與製藥產業</h1>
                        <h2>Trinka AI 精通醫學寫作</h2>
                        <p>Trinka 搭載深度理解醫學與科學寫作細節的強大 AI 技術，讓您的文章更具專業性、說服力與發表水準。</p>
                        <div class="btn-group">
                            <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">聯繫我們</button>
                            <a href="https://calendly.com/trinkaai/meet" target="_blank" id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/enterprise/medical.webp" width="500" height="469" alt="Trinka enterprise" class="img-fluid md50" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd trinka-key-features">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>專為以下領域量身打造</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="gt-features three-coloum">
                    <span class="hr-line d-sm-block d-none"></span>
                    <span class="vr-line l25"></span>
                    <span class="vr-line l50 d-sm-none"></span>
                    <span class="vr-line l75"></span>
                    <div class="gt-wrapper c-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>醫療器材與製藥公司</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>生技與生命科學機構</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>委託研究機構（CRO）</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>醫學與科學出版業</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>醫療法規與藥物警戒</h6>
                    </div>
                    <div class="gt-wrapper c-card">
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="10" fill="#763393"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                        </svg>
                        <h6>醫療行銷與傳播</h6>
                    </div>
                </div>            
            </div>
        </div>
    </div>
</section>

<app-trusted-global-leaders [sliderData]="globalSliderData"></app-trusted-global-leaders>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>
                        高品質寫作支援，助您高效產出關鍵文件
                    </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 協助團隊有效撰寫重要文件，同時確保內容符合科學寫作的品質與規範。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-none">
                    <div class="features_cards_icon">
                        <img src="/assets/images/AddtoDictionary.svg" width="40" height="40" alt="medical spell" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>醫學拼字檢查與專業詞庫</h3>
                        <p>
                            內建醫學詞典涵蓋各大醫學領域詞彙，也可自訂機構用語與品牌詞庫，確保所有文件語言一致、專業。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title">
                    <div class="features_cards_icon">
                        <img src="/assets/images/StyleGuides.png" width="40" height="40" alt="style guide" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>內建與自訂寫作風格指南</h3>
                        <p>
                            支援 AMA、APA 等技術風格準則，並可依機構需求自訂風格指南，一鍵套用，全公司溝通標準化。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/PublicationReadiness.svg" width="40" height="40" alt="publication readiness" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>技術檢查</h3>
                        <p>協助檢查研究文件是否符合 25 項以上的發表標準，加快出版流程，強化品牌研究實力。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/ppc_icon.png" width="40" height="40" alt="ppc" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>抄襲檢查</h3>
                        <p>整合全球最大學術資料庫，提供高準確度的原創性檢測。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/BulkEditingOperations.svg" width="40" height="40" alt="bulk editing" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>
                            批次編輯
                        </h3>
                        <p>批次上傳 Word 文件，由 Trinka 自動修訂後回傳標註建議的版本，大幅節省人工編修時間。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/ComprehensiveAnalytics.svg" width="40" height="40" alt="comprehensive" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>完整數據分析</h3>
                        <p>可檢視整體學習成效，或針對個別學生進行深入追蹤與診斷，提升教學成效。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/EasyUserManagement.svg" width="40" height="40" alt="easy use" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>簡易用戶管理</h3>
                        <p>
                            團隊帳號讓您輕鬆新增或移除成員，並即時管理使用額度與權限。無論是內部團隊或外包人才，都能透過 Trinka 細緻的權限控管，安全管理存取。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <img src="/assets/images/DedicatedSupport.svg" width="40" height="40" alt="dedicated support" />
                    </div>
                    <div class="features_cards_desc">
                        <h3>
                            專屬客戶成功經理
                        </h3>
                        <p>專屬客戶經理將協助您的團隊充分發揮 Trinka 的效益，服務內容包括詳細的入門說明電話、協助文件以及操作影片導覽。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-hippa-certificate></app-hippa-certificate>

<section class="border-top">
    <app-iplisting></app-iplisting>
</section>

<section class="list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-11 col-lg-10">
                            <div class="trinka-title mb-0 text-center">
                                <h2>全方位應用支援</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>深入探索 Trinka 在醫藥寫作領域的強大功能，透過針對不同產業與角色量身打造的應用情境，助您有效提升寫作效率與品質。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-none">
                                <h3>
                                    學術論文撰寫
                                </h3>
                                <p>Trinka 為學術研究與科學溝通打造專屬寫作輔助功能：</p>
                                <ul>
                                    <li>依主題領域調整專業術語與用詞</li>
                                    <li>自動套用風格指南（如 AMA、APA 等）</li>
                                    <li>提供發表前檢查，提升出版機率</li>
                                    <li>協助判斷是否符合期刊範疇</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>專業詞彙與品牌詞庫</h3>
                                <p>Trinka 協助組織標準化溝通用語並維持品牌一致性：</p>
                                <ul>
                                    <li>建立團隊或機構專屬詞彙庫</li>
                                    <li>精準偵測與修正科學術語錯誤</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>有效的品牌溝通</h3>
                                <p>協助團隊在維持品牌風格的同時，更清楚傳達關鍵訊息：</p>
                                <ul>
                                    <li>提升語氣與表達清晰度</li>
                                    <li>優化技術性語句結構</li>
                                    <li>消除語意破碎的段落</li>
                                    <li>套用客製化品牌風格指南</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>學術論文審閱</h3>
                                <p>強化論文品質與發表成功率</p>
                                <ul>
                                    <li>全面性的語言品質檢查</li>
                                    <li>一致性檢查</li>
                                    <li>出版前檢查項目支援</li>
                                    <li>支援批次編輯，大幅減少人工修訂時間</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-grammar-without-internet [windowsButton]="false"></app-grammar-without-internet>

<app-intergrade-software></app-intergrade-software>

<app-personal-pricing></app-personal-pricing>

<app-local-invoice></app-local-invoice>

<app-about-trinka></app-about-trinka>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">透過 Trinka 轉變您的企業溝通風格</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button (click)="navigationService.goToEnterpriseForm()" class="white-btn nowrap" type="button">索取報價</button>
                </div>
            </div>
        </div>  
    </div>
</div>